import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

// Mirrors the official Hotwire Native demo overflow-menu component:
// https://github.com/hotwired/hotwire-native-ios/blob/main/Demo/Bridge/OverflowMenuComponent.swift
//
// On native, this hides nothing on its own — it just registers a 3-dot
// UIBarButtonItem in the top-right of the nav bar. When the native button
// is tapped, the iOS side replies "connect", and we re-fire a click on the
// same DOM element. That click's `data-action="click->bridge--menu#show"`
// then triggers the native menu overlay built from the bridge--menu items.
export default class extends BridgeComponent {
  static component = "overflow-menu"

  connect() {
    super.connect()
    this.notifyBridgeOfConnect()
  }

  notifyBridgeOfConnect() {
    const label = this.bridgeElement.title

    this.send("connect", { label }, () => {
      this.bridgeElement.click()
    })
  }
}
